<template>
  <div class="page-width-warpper">
    <div class="news-warpper">
      <div class="left-warpper">
        <div style="width: 280px">
          <Wapper title="热门产品" :more="false">
            <ul class="news">
              <li v-for="(item, i) in hotList" :key="i" @click="toDetail(item)">
                <img :src="item.icon" />
                <div style="flex: 1">
                  <div class="name">{{ item.title }}</div>
                  <div class="time">更新：{{ item.createTime }}</div>
                </div>
              </li>
            </ul>
          </Wapper>
        </div>
      </div>
      <div style="flex: 1">
        <ul class="list">
          <li v-for="(item, i) in list" :key="i" @click="toDetail(item)">
            <img :src="item.icon" />
            <div class="name">{{ item.title }}</div>
            <div class="time">更新：{{ item.createTime }}</div>
          </li>
        </ul>
        <div style="margin: 0 auto; max-width: 600px">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wapper from "./home/components/Wapper.vue";
import { pageByCode } from "@/api/index";

export default {
  name: "News",
  components: {
    Wapper,
  },
  data() {
    return {
      list: [],
      hotList: [],
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        code: undefined,
      },
    };
  },
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(val) {
  //       this.queryParams.title = val.query.title || "";
  //       this.getList();
  //     },
  //   },
  // },
  created() {
    this.getList();
  },
  methods: {
    clearSearch() {
      this.$router.replace(`/news`);
    },
    searchList() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    getList() {
      const params = {
        ...this.queryParams,
        code: "product_display",
      };
      pageByCode(params).then((res) => {
        this.list = res.data && res.data.records;
        if (this.queryParams.pageNum === 1) {
          this.hotList = this.list;
        }
        this.total = res.data && res.data.total;
      });
    },
    toDetail(item) {
      this.$router.push(`/productDetail?id=${item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-warpper {
  padding-bottom: 15px;
  padding-top: 20px;
  display: flex;
  .left-warpper {
  }
  .news {
    margin-top: 6px;
    padding: 0 4px;
    li {
      display: flex;
      align-items: center;
      line-height: 24px;
      font-size: 12px;
      position: relative;
      margin-bottom: 12px;
      &:last-child {
        margin: 0;
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
        .name {
          color: $main-color;
          text-decoration: underline;
        }
      }
      img {
        width: 124px;
        height: 82px;
        object-fit: cover;
        display: block;
        margin-right: 12px;
        transition: all 0.5s;
      }
      .name {
        color: #555;
        cursor: pointer;
        @include clamp(2);
      }
      .time {
        margin-top: 5px;
        color: #888;
      }
    }
  }
  .list {
    margin-left: 12px;
    border: 1px solid #eee;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    li {
      cursor: pointer;
      margin: 8px;
      width: 150px;
      text-align: center;
      &:hover {
        img {
          transform: scale(1.1);
        }
        .name {
          color: $main-color;
          text-decoration: underline;
        }
      }
      img {
        width: 100%;
        height: 112px;
        object-fit: cover;
        display: block;
        margin-right: 12px;
        transition: all 0.5s;
      }
      .name {
        margin-top: 5px;
        font-size: 14px;
        font-weight: bold;
        color: $main-color;
        cursor: pointer;
        @include clamp(1);
      }
      .time {
        font-size: 12px;
        margin-top: 5px;
        color: #888;
      }
    }
  }
}
</style>
